import React, { useEffect, useState } from "react";
import { Card, Box } from "@mui/material";
import RecentDonations from "../../stream-management/components/memorial-page/components/chema/RecentDonations";
import type { Donation } from "../../stream-management/components/memorial-page/components/chema/types";
import { STORAGE_KEY } from "../../stream-management/components/memorial-page/components/chema/types";

const ChemaPanel = ({ reduxTheme }: { reduxTheme: any }) => {
  const [donations, setDonations] = useState<Donation[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored).map((d: any) => ({
          ...d,
          date: new Date(d.date),
        }));
        setDonations(parsed);
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return (
    <Card
      sx={{
        height: 482,
        backgroundColor: reduxTheme.primary_colors?.[800],
        width: 660,
        pt: 6,
        overflow: "hidden",
      }}
    >
      <Box sx={{ px: 2 }}>
        <RecentDonations donations={donations} />
      </Box>
    </Card>
  );
};

export default ChemaPanel;
